import { BaseLogApi } from './api.base';

export class BoxLogApi extends BaseLogApi {

}
